import React from 'react'
import PropTypes from 'prop-types'
import PageContainer from '../../../layout/PageContainer'
import CreditPolicyDeudorLineas from './CreditPolicyDeudorLineas'
import { useSelector } from 'react-redux';
import {
  ROLES_ASEGURADO,
  ROLES_CORREDOR,
} from 'CONST';
import { userHasRole } from '../../../../helpers/helpers';


const CreditPolicyDeudorLineasContainer = ({ location: { search, state } }) => {
  const user = useSelector((state) => state.login.user);

  // Es asegurado únicamente, no es corredor
  const isAsegurado = userHasRole(user, ROLES_ASEGURADO) && !userHasRole(user, ROLES_CORREDOR);

  const breadcrumbs = React.useMemo(() => {
    if (isAsegurado) {
      return [{ id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' }, { id: 1, name: 'MI CARTERA' }];
    }

    return [
      { id: 0, name: 'SEGURO DE CR\u00C9DITO', url: '/' },
      { id: 1, name: 'ASEGURADO', url: '/asegurado/polizas-credito' },
      { id: 2, name: 'L\u00CDNEA CARTERA CLIENTES' },
    ];
  }, [isAsegurado]);

  return (
    <PageContainer
      breadcrumbs={breadcrumbs}
      clientFilter={{
        type: 'asegurado',
        ramo: 'credito',
        showFilter: true,
      }}
      returnTo={state && state.returnTo ? state.returnTo : ''}
      returnToFull
    >
      {(client) => (
        <CreditPolicyDeudorLineas locationSearch={search} client={client} />
      )}
    </PageContainer>
  );
}

CreditPolicyDeudorLineasContainer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    state: PropTypes.shape({
      returnTo: PropTypes.string,
    }),
  }).isRequired,
};

export default CreditPolicyDeudorLineasContainer;
